export const FETCHING = 'FETCHING';
export const FETCHED = 'FETCHED';
export const DONE = 'DONE';
export const PAGE_CHANGED = 'PAGE_CHANGED';
export const READYED = 'READYED';
export const RESET = 'RESET';
